import Loadable from 'react-loadable';
import Loading from '../components/OrganizationSignup2/Loading';

export default Loadable({
  loader: () => import('containers/OrganizationSignup2Container'),
  loading: Loading,
});
